<template>
  <Modal
    :title="computedTitle"
    :modal="modalLicenca"
    max-width="960px"
    cardTextClass="pa-0"
    @close="$emit('close')"
    @save="save"
  >
    <div slot="header-right">
      <v-btn fab small text @click="$emit('close')" class="mr-3">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn fab small color="primary" @click="save">
        <v-icon>mdi-check</v-icon>
      </v-btn>
    </div>
    <Tabs
      slot="inner-body"
      background-color="grey lighten-3"
      :tabsHeader="licencaTabs"
      :tab="tab"
      headerKey="descricao"
      @tabChanged="tab = $event"
    >
      <v-form
        slot="Informações"
        @submit.prevent="save"
        v-model="valid"
        ref="licencaForm"
        lazy-validation
      >
        <v-row wrap class="px-4">
          <v-col cols="12" sm="8" class="pb-0">
            <v-menu
              ref="menu"
              v-model="menuDataExpiracao"
              :close-on-content-click="false"
              :return-value.sync="licenca.data_expiracao"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Data Expiração"
                  readonly
                  filled
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataExpiracao"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menuDataExpiracao = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(dataExpiracao)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="4" class="pb-0">
            <Input
              @input="licenca.conexoes_simultaneas = $event"
              :value="licenca.conexoes_simultaneas"
              label="Conexões Simultâneas"
              name="conexoes_simultaneas"
              :rules="[rules.required]"
              filled
              required
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <Input
              @input="licenca.cpf_cnpj = $event"
              :value="licenca.cpf_cnpj"
              label="CPF/CNPJ"
              name="cpf_cnpj"
              :rules="[rules.required]"
              :autofocus="modalLicenca"
              filled
              required
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <Input
              @input="licenca.titulo = $event"
              :value="licenca.titulo"
              label="Título"
              name="titulo"
              :rules="[rules.required]"
              filled
              required
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <Autocomplete
              @change="changeAplicativo"
              :value="licenca.aplicativo.app_key.descricao"
              :items="aplicativos"
              label="Aplicativo"
              item-text="descricao"
              return-object
              name="aplicativo"
              :rules="[rules.required]"
              filled
              required
            />
          </v-col>

          <v-col cols="12" sm="8" class="py-0">
            <Input
              @input="licenca.aplicativo.host = $event"
              :value="licenca.aplicativo.host"
              label="Host"
              name="host"
              filled
            />
          </v-col>

          <v-col cols="12" sm="4" class="py-0">
            <Input
              @input="licenca.aplicativo.id_empresa = $event"
              :value="licenca.aplicativo.id_empresa"
              label="ID Empresa"
              name="id_empresa"
              filled
            />
          </v-col>
        </v-row>
      </v-form>

      <v-col slot="Usuários" cols="12" class="pt-0">
        <v-card flat>
          <v-card-title class="pa-0 justify-space-between">
            <span class="body-1 font-weight-bold">Usuários ({{ licenca.usuarios.length }})</span>
            <v-col cols="4">
              <Autocomplete
                :items="usuarios"
                label="Selecione"
                name="usuarios"
                item-text="nome"
                return-object
                @change="changeUsuario"
                filled
                dense
                hide-details
                :resetAfterChange="true"
              />
            </v-col>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-card v-if="licenca.usuarios.length">
              <ListItem
                v-for="usuario of licenca.usuarios"
                :key="usuario._id"
                :title="usuario.client_key.nome"
                dense
                @icon-clicked="deleteUsuario(usuario.client_key._id)"
              />
            </v-card>
            <Alert v-else text="Nenhum usuário adicionado nessa licença" />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col slot="Recursos" cols="12">
        <v-sheet class="pa-4 primary lighten-2">
          <v-row class="align-center">
            <v-col cols="9">
              <v-text-field
                v-model="search"
                label="Pesquisar"
                dark
                flat
                solo-inverted
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                text
                dark
                @click="expandOrCollapseAll"
              >
                <v-icon left>{{ expandOrCollapseIcon }}</v-icon>
                {{ expandOrCollapseText }}
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
        <v-col cols="12" class="px-0">
          <v-treeview
            v-if="recursosTreeView.length"
            v-model="licenca.recursos"
            :items="recursosTreeView"
            item-key="recurso"
            item-text="descricao"
            item-children="recursos"
            selectable
            return-object
            open-on-click
            :search="search"
            :open-all="expandAll"
            :key="treeviewKey"
          ></v-treeview>
          <Alert v-else text="Nenhum recurso adicionado nessa licença" />
        </v-col>
      </v-col>
    </Tabs>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { formatDate } from '../../helpers';
import Modal from '../shared/Modal';
import Input from '@/components/shared/Input';
import Autocomplete from '@/components/shared/Autocomplete';
import ListItem from '@/components/shared/ListItem';
import Alert from '@/components/shared/Alert';
import Tabs from '@/components/shared/Tabs';
import Licenca from '@/domain/Licenca';

export default {
  name: 'ModalLicenca',
  props: {
    modalLicenca: {
      type: Boolean,
      default: false
    },
    editLicenca: {
      default: null
    }
  },
  components: {
    Modal,
    Input,
    Autocomplete,
    ListItem,
    Alert,
    Tabs
  },
  data: () => ({
    tab: '',
    recursosTreeView: [],
    expandAll: false,
    treeviewKey: 0,
    hasErrors: false,
    search: '',
    valid: true,
    licenca: new Licenca(),
    licencaRecursoInicial: [],
    dataExpiracao: new Date().toISOString().substr(0, 10),
    menuDataExpiracao: false
  }),
  watch: {
    modalLicenca(value) {
      if (value) {
        if (!this.aplicativos.length) this.fetchAplicativos({ limit: 999 });
        if (!this.usuarios.length) this.fetchUsuarios({ limit: 999 });
      } else if (!value) {
        this.resetModalData();
      }
    },
    editLicenca(value) {
      if (value) {
        this.licenca = value;
        this.dataExpiracao = this.licenca.data_expiracao && this.licenca.data_expiracao.substr(0, 10);
        this.recursosTreeView = value.aplicativo.app_key.recursos ? value.aplicativo.app_key.recursos : [];
        this.carregaRecursosInicial();
      }
    },
  },
  computed: {
    ...mapGetters(['loading', 'rules', 'aplicativos', 'usuarios']),
    expandOrCollapseIcon() {
      return this.expandAll ? 'mdi-collapse-all' : 'mdi-expand-all';
    },
    expandOrCollapseText() {
      return this.expandAll ? 'Recolher Tudo' : 'Expandir Tudo';
    },
    licencaTabs() {
      return this.hasErrors ?
      [
        { descricao: 'Informações', icon: 'mdi-alert-circle', iconColor: 'error' },
        { descricao: 'Usuários' },
        { descricao: 'Recursos' },
      ] :
      [
        { descricao: 'Informações' },
        { descricao: 'Usuários' },
        { descricao: 'Recursos' },
      ]
    },
    dateFormatted() {
      return formatDate(this.licenca.data_expiracao);
    },
    computedTitle() {
      return this.editLicenca ? 'Edita Licença' : 'Nova Licença';
    }
  },
  methods: {
    ...mapActions(['addLicenca', 'updateLicenca', 'fetchAplicativos', 'fetchUsuarios']),
    buscaLicencaInicial(recursos, nome) {
      for (const rec of recursos) {
        if ((rec.recurso === nome) && (rec.liberado)) {
          return true;
        }

        if (rec.recursos && rec.recursos.length) {
          if (this.buscaLicencaInicial(rec.recursos, nome)) {
            return true;
          }
        }
      }

      return false;
    },
    buscaRecursoLiberado(recurso, nome) {
      if ((recurso.recurso === nome) && (recurso.liberado)) {
        return true;
      }
      
      if (recurso.recursos && recurso.recursos.length) {
        for (const rec of recurso.recursos) {
          if (this.buscaRecursoLiberado(rec, nome)) {
            return true;
          }
        }
        // recurso.recursos.forEach(rec => {
        //   if (this.buscaRecursoLiberado(rec, nome)) {
        //     return true;
        //   }
        //   // this.buscaRecursoLiberado(rec, nome);
        // });
      }

      return false;
    },
    carregaRecursoInicial(recurso) {
      recurso.liberado = this.buscaLicencaInicial(this.licencaRecursoInicial, recurso.recurso);

      if (recurso.liberado && !recurso.recursos.length) {
        this.licenca.recursos.push(recurso);
      }

      if (recurso.recursos && recurso.recursos.length) {
        for (const rec of recurso.recursos) {
          this.carregaRecursoInicial(rec);
        }
      }
    },
    carregaRecursosInicial() {
      this.licencaRecursoInicial = [ ...this.licenca.recursos ];

      this.licenca.recursos = [];

      for (const rec of this.recursosTreeView) {
        this.carregaRecursoInicial(rec);
      }
    },
    buscaRecursoLicenca(recurso, nome) {
      const recursoLiberado = this.licenca.recursos.some(recursoLicenca => recursoLicenca.recurso === nome);

      if (recursoLiberado) {
        return true;
      } else if (recurso.recursos && recurso.recursos.length) {
        for (const rec of recurso.recursos) {
          if (this.buscaRecursoLicenca(rec, rec.recurso)) {
            return true;
          }
        }
      }

      return false;
    },
    buscaRecursoNaoLiberado(recurso) {
      if (!recurso.liberado) {
        return true;
      }

      for (const rec of recurso.recursos) {
        if (!rec.liberado) {
          return true;
        }

        if (rec.recursos && rec.recursos.length) {
          for (const recc of rec.recursos) {
            if (this.buscaRecursoNaoLiberado(recc)) {
              return true;
            }
          }
        }
      }

      return false;
    },
    atualizaRecursoCompleto(recurso) {
      recurso.recursos_completos = !(recurso.recursos && recurso.recursos.length);

      if (!recurso.recursos_completos) {
      // if (recurso.recursos && recurso.recursos.length) {
        recurso.recursos_completos = !this.buscaRecursoNaoLiberado(recurso);
        
        if (recurso.recursos && recurso.recursos.length) {
          for (const rec of recurso.recursos) {
            this.atualizaRecursoCompleto(rec);
          }
        }
      // }
      }
    },
    atualizaLiberado(recurso) {
      // recurso.liberado = this.licenca.recursos.some(recursoLicenca => recursoLicenca.recurso === recurso.recurso);
      recurso.liberado = this.buscaRecursoLicenca(recurso, recurso.recurso);

      if (recurso.recursos && recurso.recursos.length) {
        for (const rec of recurso.recursos) {
          this.atualizaLiberado(rec);
        }
      }
    },
    atualizarLiberados() {
      for (const recurso of this.recursosTreeView) {
        this.atualizaLiberado(recurso);
      }

      for (const recurso of this.recursosTreeView) {
        this.atualizaRecursoCompleto(recurso);
      }
    },
    getAplicativos() {
      this.fetchAplicativos({ limit: 999 });
    },
    changeUsuario(obj) {
      const usuarioJaExiste = this.licenca.usuarios.find(usuario => usuario.client_key._id === obj._id);
      if (usuarioJaExiste) return;

      const newUsuario = { 
        client_key: {
          _id: obj._id,
          nome: obj.nome
        }
      }
      this.licenca.usuarios.push(newUsuario);
    },
    changeAplicativo(obj) {
      this.licenca.aplicativo.app_key.descricao = obj.descricao;
      this.licenca.aplicativo.app_key._id = obj._id;
    },
    changeDataExpiracao(date) {
      this.licenca.data_expiracao = date;
      this.closeModalDataExpiracao();
    },
    deleteUsuario(id) {
      this.licenca.usuarios = this.licenca.usuarios.filter(usuario => usuario.client_key._id !== id);
    },
    resetModalData() {
      this.licenca = new Licenca();
      this.valid = true;
      this.tab = 'tab-Informações';
      this.search = '';
      this.recursosTreeView = [];
      this.expandAll = false;
      this.treeviewKey = 0;
      this.hasErrors = false;
      this.dataExpiracao = new Date().toISOString().substr(0, 10);
    },
    expandOrCollapseAll() {
      this.expandAll = !this.expandAll;
      this.treeviewKey++;
    },
    save() {
      if (this.$refs.licencaForm.validate()) {
        this.licenca.data_expiracao = new Date(this.dataExpiracao);

        if (this.editLicenca) {
          this.atualizarLiberados();
          this.licenca.recursos = this.recursosTreeView;
          this.updateLicenca({ ...this.licenca });
          this.$emit('close');
        } else {
          this.addLicenca({ ...this.licenca });
          this.$emit('close');
        }
      } else {
        this.hasErrors = true;
      }
    }
  }
}
</script>

<style>

</style>